import { cloneElement, isValidElement, type ReactElement, type ReactNode, useId } from 'react';
import { Field } from '../../ui/form';

/** Поле формы, у которого подпись связана с полем ввода (для чтения с экрана и автотестов) */
export function LField({
  label,
  hint,
  error,
  className,
  children,
}: {
  label: string;
  hint?: ReactNode;
  error?: string;
  className?: string;
  children: ReactNode;
}) {
  const id = useId();
  const child = isValidElement(children)
    ? cloneElement(children as ReactElement<{ id?: string }>, { id })
    : children;
  return (
    <Field
      label={label}
      hint={hint}
      error={error}
      className={className}
      htmlFor={isValidElement(children) ? id : undefined}
    >
      {child}
    </Field>
  );
}
